import { checkAuth } from './auth';

export const types = {
    REMOVE_PAGE_REQUEST: 'REMOVE_PAGE_REQUEST',
    REMOVE_PAGE_SUCCESS: 'REMOVE_PAGE_SUCCESS',
    REMOVE_PAGE_FAILURE: 'REMOVE_PAGE_FAILURE',

    FETCH_PAGE_REQUEST: 'FETCH_PAGE_REQUEST',
    FETCH_PAGE_SUCCESS: 'FETCH_PAGE_SUCCESS',
    FETCH_PAGE_FAILURE: 'FETCH_PAGE_FAILURE',

    CREATE_PAGE_REQUEST: 'CREATE_PAGE_REQUEST',
    CREATE_PAGE_SUCCESS: 'CREATE_PAGE_SUCCESS',
    CREATE_PAGE_FAILURE: 'CREATE_PAGE_FAILURE',
};

export const removePage = (payload) =>
    checkAuth({ payload, type: types.REMOVE_PAGE_REQUEST });

export const removePageSuccess = (payload) => ({
    payload,
    type: types.REMOVE_PAGE_SUCCESS,
});

export const fetchPage = (pageId) =>
    checkAuth({ pageId, type: types.FETCH_PAGE_REQUEST });

export const fetchPageSuccess = (payload) => ({
    payload,
    type: types.FETCH_PAGE_SUCCESS,
});

export const createOrUpdatePage = (payload) =>
    checkAuth({ ...payload, type: types.CREATE_PAGE_REQUEST });

export const createOrUpdatePageSuccess = (payload) => ({
    payload,
    type: types.CREATE_PAGE_SUCCESS,
});
